import { PublicProjectTypesAndCodeTemplate, PublicTemplate } from "../../../templates";

const ProjectTypesAndCode = (): JSX.Element => {
  return (
    <PublicTemplate activeElement="Project types & standards" isContentUnwrapped>
      <PublicProjectTypesAndCodeTemplate />
    </PublicTemplate>
  );
};

export default ProjectTypesAndCode;
